"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCloudflareWorkers = void 0;
function isCloudflareWorkers() {
    return false;
}
exports.isCloudflareWorkers = isCloudflareWorkers;
